import * as React from 'react'  
import _ from 'underscore';
  
const ResponsePageNumbers = ({ numberOfPages, responsePageNumber, updatePageNumber, }) => {
  const pageNumbers = _.range(1, numberOfPages + 1);

  const incrementPageNumber = () => {
    if (responsePageNumber >= numberOfPages) { return }
    
    updatePageNumber(responsePageNumber + 1);
  }

  const decrementPageNumber = () => {
    if (responsePageNumber === 1) { return }
    
    updatePageNumber(responsePageNumber - 1);
  }

  let pageNumberStyle = {};
  const numbersToRender = pageNumbers.map((pageNumber, i) => {
    if (responsePageNumber === pageNumber) {
      pageNumberStyle = {
        backgroundColor: 'lightblue',
      };
    } else {
      pageNumberStyle = {};
    }
    return (
      <li key={i}>
        <a className="button" onClick={() => updatePageNumber(pageNumber)} style={pageNumberStyle}>
          {pageNumber}
        </a>
      </li>
    );
  });

  let nextButtonClassName = 'button pagination-extreme-button';
  if (responsePageNumber === numberOfPages) {
    nextButtonClassName += ' is-disabled';
  }
  const nextButton = (
    <a className={nextButtonClassName} onClick={incrementPageNumber}>
      Next
    </a>
  );

  let prevButtonClassName = 'button pagination-extreme-button';
  if (responsePageNumber === 1) {
    prevButtonClassName += ' is-disabled';
  }
  const prevButton = (
    <a className={prevButtonClassName} onClick={decrementPageNumber}>
      Prev
    </a>
  );

  return (
    <div>
      <div className="response-pagination-container">
        <nav className="pagination response-pagination">
          {prevButton}
          <ul className="numbers-list">{numbersToRender}</ul>
          {nextButton}
        </nav>
      </div>
    </div>
  );
};

export { ResponsePageNumbers, }
